<div>
    <cmps-transcript-dialog-focus></cmps-transcript-dialog-focus>
</div>
<div *ngIf="_service.state?.summaryEnabled === true">
    <cmps-transcript-dialog-summary></cmps-transcript-dialog-summary>
</div>
<div class="cmps-cdk-h-8px cmps-cdk-bg-color-unknown-114"></div>
<div *ngIf="_service.state?.evaluationEnabled === true">
    <cmps-ca-evaluation-result-main
        [caResult]="_service.state?.transcript?.caResult"
        [collapsed]="true"
    ></cmps-ca-evaluation-result-main>
</div>
<div class="cmps-cdk-d-flex cmps-cdk-justify-content-flex-end cmps-cdk-p-1">
    <button
        class="cmps-cdk-border-color-blue-100 cmps-cdk-color-blue-100 not:disabled:hover:cmps-cdk-bg-color-blue-100 not:disabled:focus:cmps-cdk-bg-color-blue-100 not:disabled:hover:cmps-cdk-color-white not:disabled:focus:cmps-cdk-color-white not:disabled:hover:cmps-cdk-pseudo-child not:disabled:focus:cmps-cdk-pseudo-child"
        cmpsOutlineButton
        (click)="_onCreateNotesClick()"
    >
        <cmps-icon
            class="cmps-cdk-fill-blue-100 not:disabled:hover:cmps-cdk-fill-white not:disabled:focus:cmps-cdk-fill-white"
            svgIcon="note-edit-outline"
        ></cmps-icon>
        <span cmpsOutlineButtonLabel>{{
            _i18n._11208_CREATE_NOTES | translate
        }}</span>
    </button>
</div>
